import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../../../services/AxiosInstance';

const Tab3SentCandidates = ({ id }) => {

    const [candidates, setCandidates] = useState([]);

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = (page = 1) => {
        axiosInstance(`can-applyjob/?job=${id}&status__in=ap,is,ic,r&page=${page}`)
            .then(res => setCandidates(res.data?.results));
    }

    return (
        <table className="table-job-bx cv-manager company-manage-job">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Sent</th>
                    <th>Interview</th>
                    <th>Appointed</th>
                    <th>Rejected</th>
                    <th>Rejected Reason</th>
                </tr>
            </thead>
            <tbody>
                {
                    candidates?.length > 0 ? candidates?.map(res => {
                        return (
                            <tr key={res.id}>
                                <td className="job-name">
                                    <Link to={"#"}>{res.name}</Link>
                                </td>
                                <td className="application text-primary">{res.status}</td>
                                <td className="application text-primary">{res?.created_on || '-'}</td>
                                <td className="application text-primary">{res?.interview_time || '-'}</td>
                                <td className="application text-primary">{res?.hire_time || '-'}</td>
                                <td className="application text-primary">{res?.rej_time || '-'}</td>
                                <td className="application text-primary text-truncate" style={{ maxWidth: "10rem" }} title={res?.rej_reason}>{res?.rej_reason || '-'}</td>
                            </tr>
                        )
                    })
                        :
                        <tr>
                            <td colSpan="7" className="text-center">No data found</td>
                        </tr>
                }
            </tbody>
        </table>
    );
};

export default Tab3SentCandidates;